import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-logo';
import styles from 'frontend-login/components/register-error/card-header-title.module.css';
import { Illustration } from 'frontend-utils/index';

<template>
  <a class={{styles.platform-logo-link}} href="/">
    <Illustration
      @html={{ICONS_LOGOS_MAP.logo-color-with-text}}
      class={{styles.platform-logo-illustration}}
    />
  </a>
</template>
